<div class="sdp-wizard-top-container sdp-breadcrumb-container">
	<mat-horizontal-stepper>
		<mat-step *ngFor="let page of pages">
			<ng-template matStepLabel>
				<div (click)="goTo(page.page)" class="sdp-breadcrumb-step-container">
					<span class="sdp-breadcrumb-circle" [class.sdp-breadcrumb-selected]="selectedPage===page.page">
						<sdp-icon [icon]="page.icon" [matTooltip]="showToolTip ?  getStepperToolTip(page.title) : ''"></sdp-icon>
					</span>
					<span class="sdp-breadcrumb-text sdp-ellipsis" [class.sdp-breadcrumb-selected]="selectedPage===page.page">
						{{ page.title | translate }}
					</span>
				</div>
			</ng-template>
		</mat-step>
	</mat-horizontal-stepper>
</div>